import { createContext } from 'react';
import type { Observer } from '@tob/shared/intersection-observer';

export interface GlobalContextInterface {
  userAgent: string;
  theme: unknown;
  lazyLoadObserver: Observer | null;
}

export const globalContextDefault: GlobalContextInterface = {
  userAgent: '',
  theme: {},
  lazyLoadObserver: null,
};

export const GlobalContext = createContext<GlobalContextInterface>(
  globalContextDefault
);
